<script setup>
import { computed } from 'vue'
import { useTranslaterStore } from '@/stores/translater'
import { useRequestsStore } from '@/stores/requests'
import { useProfileStore } from '@/stores/profile'
import userName from '@/helpers/userName'

const translaterStore   = useTranslaterStore()
const requestsStore     = useRequestsStore()
const profileStore      = useProfileStore()

const getTranslate  = computed(() => translaterStore.getTranslate)
const profile       = computed(() => profileStore.profile)

const profileUuid =  localStorage.getItem('UTA_UUID') || ''

profileStore.readProfile(profileUuid)

</script>

<template>
    <div class="uta-header-profile">
        <router-link :to="`/users/${profile.uuid}`" class="uta-header-profile__name">
            <span class="material-icons uta-header-profile__name-icon">
                person
            </span>
            <div class="uta-header-profile__name-text">
                {{ userName(profile) || getTranslate.USERS_NEW_USER }}
            </div>
        </router-link>
        <div class="uta-header-profile__logout">
            <a class="uta-header-profile__logout-link" href="#" @click.prevent="requestsStore.logout()" :title="getTranslate.PROFILE_LOGOUT">
                <span class="material-icons">
                    logout
                </span>
            </a>
        </div>
    </div>
</template>

<style lang="scss">
@import '@/assets/styles/scss/components/header-profile';
</style>